<template>
  <div>
    <vee-field v-slot="{ field, errorMessage }" v-model="computedModelValue" :rules="rules" :name="name"
      :label="label || name">
      <div>
        <textarea :id="id" :data-test-id="dataTestId" :class="[inputClass, { 'error-border': bannedWordIsPresent }, 'inputFieldClass']" :placeholder="placeholder" :name="name"
          :rows="rows" :maxlength="maxlength" v-bind="field" @keydown.enter.prevent.stop @blur="onBlur" />
      </div>
      <div v-show="showErrorMessage" class="mt-error" :class="errorClass" :data-test-id="`${dataTestId}-error`">
        {{ errorMessage }}
      </div>
      <p v-if="bannedWordIsPresent" class="mt-error" :class="errorClass">
        {{$t('pages.profile.foundry_profile.banned_word_error_message')}}
      </p>
      <p v-if="warningWordIsPresent" class="mt-error warning" :class="errorClass" :style="{ color: '#DC5800' }">
        {{ $t('pages.profile.foundry_profile.warning_word_error_message', {words: warningWords.join('", "')}) }}
      </p>
    </vee-field>
  </div>
</template>

<script setup>
import { computed , ref } from 'vue'
import Misc from 'src/utils/helper/misc'
import { useStore } from 'vuex';
import i18n from 'src/assets/i18n/i18n'
const { t } = i18n().global
const store = useStore();

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  name: {
    type: String,
    required: true
  },
  id: {
    type: String,
    default: 'id',
    required: true
  },
  dataTestId: {
    type: String,
    default: 'test-id'
  },
  placeholder: {
    type: String,
    default: 'Type text'
  },
  label: {
    type: String,
    default: ''
  },
  inputClass: {
    type: Array,
    default: () => []
  },
  errorClass: {
    type: [String, Object, Array],
    default: () => []
  },
  rules: {
    type: String,
    default: ''
  },
  showErrorMessage: {
    type: Boolean,
    default: true
  },
  rows: {
    type: String,
    default: '2'
  },
  maxlength: {
    type: String,
    default: ''
  },
  moduleName: {
    type: String,
    default: ''
  },
  foundryId: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue', 'blur', 'update-banned-word'])
const computedModelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

const bannedWordIsPresent = ref(false)
const warningWordIsPresent = ref(false)
const warningWords = ref([])
const previousWarningWords = ref([]);
const previousBannedWords = ref([]);

const onBlur = () => {
  const bannedWordInfo = Misc.strikeThroughBadWords(props.description , store , 'text-area' , props.moduleName , props.foundryId, previousWarningWords.value, previousBannedWords.value)
  bannedWordIsPresent.value = bannedWordInfo.bannedWordExist
  warningWordIsPresent.value = bannedWordInfo.warningWordExist
  warningWords.value = bannedWordInfo.warningWordMatches
  previousWarningWords.value = bannedWordInfo.warningWordMatches;
  previousBannedWords.value = bannedWordInfo.banned;
  emit('update-banned-word', bannedWordInfo.bannedWordExist)
}
</script>

<style scoped>
.error-border {
  border: 1px solid #E3152E;
  border-left-width: 0.375rem;
  width: 100%;
  outline: none;
}
.inputFieldClass {
  margin-bottom: 0.25rem;
}
</style>
